import React from "react";

type TooltipProps = {
  children: React.ReactNode;
  className?: string;
  // future: position, visible, delay etc.
};

const Tooltip: React.FC<TooltipProps> = ({ children, className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      <div className="absolute -top-20 left-1/2 transform -translate-x-1/2 px-3 py-1 rounded-md bg-main-purple text-white text-sm whitespace-nowrap z-50">
        {children}
        <div
          className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-3 h-3 bg-main-purple rotate-45 z-50"
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export default Tooltip;
